<template>
  <div>
    <h4><i class="fas fa-car"></i> Parking</h4>
    <b-table :items="parking" :fields="['reference_number', 'address_line_1', 'authority', 'first_name', 'dob', 'effective_from']">
      <template #cell(reference_number)="data"><code>{{ data.value }}</code></template>
      <template #cell(authority)="data"><authority :authority="data.value"/></template>
      <template #cell(first_name)="data">{{ data.value }} {{ data.item.last_name }}</template>
      <template #cell(dob)="data">{{ data.value || 'Not on file' }}</template>
      <template #cell(effective_from)="data">
        {{ data.value | moment('Do MMM YYYY') }}<br/>
        until {{ data.item.effective_to | moment('Do MMM YYYY') }}
      </template>
    </b-table>
  </div>
</template>

<script>
import Authority from '../Authority.vue'

export default {
  components: { Authority },
  props: ['parking']
}
</script>
